import React from "react"
import Layout from "../../components/common/Layout"
import { MetaData as MetaTags } from "../../components/common/meta"
import IRacingTelemetryReport from "../../components/reports/IRacingTelemetryReport"
import report from "../../data/iracing-algarve-gt3-report.json"

const IRacingAlgarveGT3TelemetryReportPage = ({ location }) => (
    <Layout bodyClass="iracing-telemetry-report" hideFooter>
        <MetaTags
            title="iRacing Telemetry Analysis Example | Porsche GT3 Algarve"
            description="Explore a measured iRacing telemetry analysis for a Porsche 911 GT3 R at Algarve, with lap comparison, racing lines, braking, throttle, steering and section coaching."
            canonicalPath="/iracing-coaching-report/"
            location={location}
        />
        <IRacingTelemetryReport report={report} />
    </Layout>
)

export default IRacingAlgarveGT3TelemetryReportPage
